// Copyright (c) 2023-2025 Matthias von Laer
// This file is part of Carsharing and is licensed under GNU Affero General Public License 3.0 or any later version. 

import io from 'socket.io-client'
import {CollectionModel} from './CollectionModel.js'
import {HttpSession} from './HttpSession.js'
import {isOffice} from './Office.js'

export class BackendModel {
  constructor(host, token) {
    this.host = host
    this.session = new HttpSession(token)
    this.buchungen = new CollectionModel(this.session, `${this.host}/buchungen`)
    this.fahrzeuge = new CollectionModel(
      this.session,
      `${this.host}/fahrzeuge`,
      `?type=${isOffice() ? "office" : "vehicle"}`)
    this.kosten = new CollectionModel(this.session, `${this.host}/kosten`)
    this.kostenstellen = new CollectionModel(this.session, `${this.host}/kostenstellen`)
    this.abrechnungen = new CollectionModel(this.session, `${this.host}/abrechnungen`)
    this.buchhaltung = new CollectionModel(this.session, `${this.host}/buchhaltung`)
    this.socket = new io(host, { path: "/ws/socket.io/", transports: ['websocket', 'polling']});
  }

  async getDateTime() {
    return await this.session.get(`${this.host}/date-time`)
  }

  async abrechnungAuswerten(abrechnungsId) {
    return await this.session.post(`${this.host}/abrechnungen/${abrechnungsId}/auswerten`)
  }
}
